// Icon preloader utility for instant icon loading and caching

// List of all game icons to preload
const GAME_ICONS = [
  '/main/games/icons/8bp.webp',
  '/main/games/icons/99nitf.webp',
  '/main/games/icons/adoptme.jpeg',
  '/main/games/icons/alibiononline.webp',
  '/main/games/icons/allstartowerdefense.jpeg',
  '/main/games/icons/animalcrossing.jpg',
  '/main/games/icons/animedefenders.webp',
  '/main/games/icons/animevanguards.jpg',
  '/main/games/icons/arksurvivalascended.webp',
  '/main/games/icons/Arknights.png',
  '/main/games/icons/AyakashiRumble.webp',
  '/main/games/icons/battlenet.jpg',
  '/main/games/icons/battlefield6.webp',
  '/main/games/icons/arenabreakout1.jpg',
  '/main/games/icons/arenabreakout.jpg',
  '/main/games/icons/Blackclover.jpeg',
  '/main/games/icons/blackdessertonline.png',
  '/main/games/icons/Bleachbravesouls.webp',
  '/main/games/icons/bloodstrike.webp',
  '/main/games/icons/bloxfruits.jpg',
  '/main/games/icons/brawl-stars.webp',
  '/main/games/icons/codmobile.webp',
  '/main/games/icons/genshinimpact.avif',
  '/main/games/icons/mobilelegends.webp',
  '/main/games/icons/cs2.png',
  '/main/hero section/promos/navbaricons/CS2.png',
  '/main/hero section/promos/navbaricons/Fortnite.png',
  '/main/hero section/promos/navbaricons/Roblox.png',
  '/main/hero section/promos/navbaricons/Valorant.png',
  '/main/hero section/promos/navbaricons/Worldofwarcraft.png',
  '/main/hero section/promos/navbaricons/Clashroyale.png',
  '/main/hero section/promos/navbaricons/ApexLegends.png',
  '/main/hero section/promos/navbaricons/ARcraiders.png',
  '/main/hero section/promos/navbaricons/Callofduty.png',
  '/main/hero section/promos/navbaricons/EAsports.png',
  '/main/hero section/promos/navbaricons/Escapefromtarkov.png',
  '/main/hero section/promos/navbaricons/Leagueoflegends.png',
  '/main/hero section/promos/navbaricons/Oldschoolrunescape.png',
  '/main/hero section/promos/navbaricons/Rainbowsix.png',
  '/main/hero section/promos/navbaricons/rocketleague.png',
];

// Cache for preloaded images
const imageCache = new Map();

/**
 * Preload a single image
 */
const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    // Check cache first
    if (imageCache.has(src)) {
      resolve(imageCache.get(src));
      return;
    }

    const img = new Image();
    img.onload = () => {
      imageCache.set(src, img);
      resolve(img);
    };
    img.onerror = reject;
    img.src = src;
  });
};

/**
 * Preload all game icons
 */
export const preloadAllIcons = async () => {
  try {
    const preloadPromises = GAME_ICONS.map(src => 
      preloadImage(src).catch(err => {
        console.warn(`Failed to preload icon: ${src}`, err);
        return null;
      })
    );
    
    await Promise.all(preloadPromises);
    console.log('All game icons preloaded');
  } catch (error) {
    console.error('Error preloading icons:', error);
  }
};

/**
 * Preload icons in the background (non-blocking)
 */
export const preloadIconsInBackground = () => {
  // Use requestIdleCallback if available, otherwise setTimeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      preloadAllIcons();
    }, { timeout: 2000 });
  } else {
    setTimeout(() => {
      preloadAllIcons();
    }, 100);
  }
};

/**
 * Check if image is cached
 */
export const isImageCached = (src) => {
  return imageCache.has(src);
};
